export class ApiException implements Error {
  public name = 'ApiException';
  public ExceptionType: string = undefined;
  public ExceptionMessage: string = undefined;
  public Message: string = undefined;
  public StackTrace: string = undefined;

  public get message(): string {
    return this.ExceptionMessage;
  }

  constructor(source?) {
    for (const key in this) {
      if (key in source) {
        this[key] = source[key];
      }
    }
  }

  public toString(): string {
    return this.ExceptionMessage;
  }

}
